import React from 'react';
import { L10nHTML, useL10n, useTranslatableErrors } from '@uplift/hooks';
import { Alert } from '../../../../Alert';
import { useCalendarEventPopoverActions } from '../../../../Calendar';
import { useFormContext } from '../AddSessionForm.types';


export const AddSessionStatusAlert = () => {
  const l10n = useL10n();
  const formikContext = useFormContext();
  const error = useTranslatableErrors(l10n.schedule.createAppointment.providerErrors, formikContext.status?.errorDescription);
  const calendarEventPopoverActions = useCalendarEventPopoverActions();

  React.useEffect(() => {
    calendarEventPopoverActions.current?.updatePosition();
  }, [ error, formikContext.status?.errorDisplayed ]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!formikContext.status?.errorDisplayed) {
    return null;
  }

  return (
    <Alert severity="error" title={error.title} icon={false}>
      <L10nHTML variant="body2" color="inherit">
        {error.body}
      </L10nHTML>
    </Alert>
  );
};
